import React from 'react';
import { Loader } from 'semantic-ui-react';

const SplashScreen = props => {
  return (
    <Loader active >
      Connecting to server...
    </Loader>
  )
}
 
export default SplashScreen;


// WEBPACK FOOTER //
// ./src/components/SplashScreen.js